declare namespace $ {

	type $mol_paragraph__dom_name_shm_hitalama_map_widget_float_file_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_file['title_dom_name'] >
		,
		ReturnType< $mol_paragraph['dom_name'] >
	>
	type $mol_paragraph__title_shm_hitalama_map_widget_float_file_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_file['name'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_file_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__style_shm_hitalama_map_widget_float_file_4 = $mol_type_enforce<
		({ 
			'width': ReturnType< $shm_hitalama_map_widget_float_file['baza_download_progress_width'] >,
		})  & ReturnType< $mol_view['style'] >
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_text__text_shm_hitalama_map_widget_float_file_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_file['baza_download_progress_status'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_text__style_shm_hitalama_map_widget_float_file_6 = $mol_type_enforce<
		({ 
			'color': ReturnType< $shm_hitalama_map_widget_float_file['baza_download_progress_color'] >,
		})  & ReturnType< $mol_text['style'] >
		,
		ReturnType< $mol_text['style'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_file_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__style_shm_hitalama_map_widget_float_file_8 = $mol_type_enforce<
		({ 
			'width': ReturnType< $shm_hitalama_map_widget_float_file['baza_upload_progress_width'] >,
		})  & ReturnType< $mol_view['style'] >
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_text__text_shm_hitalama_map_widget_float_file_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_file['baza_upload_progress_status'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_text__style_shm_hitalama_map_widget_float_file_10 = $mol_type_enforce<
		({ 
			'color': ReturnType< $shm_hitalama_map_widget_float_file['baza_upload_progress_color'] >,
		})  & ReturnType< $mol_text['style'] >
		,
		ReturnType< $mol_text['style'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_file_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_text__text_shm_hitalama_map_widget_float_file_12 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_file['tg_send_status'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_text__style_shm_hitalama_map_widget_float_file_13 = $mol_type_enforce<
		({ 
			'color': ReturnType< $shm_hitalama_map_widget_float_file['tg_send_status_color'] >,
		})  & ReturnType< $mol_text['style'] >
		,
		ReturnType< $mol_text['style'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_float_file_14 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_file_15 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_file['tg_send_upload'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $shm_hitalama_audio_player__uri_shm_hitalama_map_widget_float_file_16 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_file['audio_uri'] >
		,
		ReturnType< $shm_hitalama_audio_player['uri'] >
	>
	type $shm_hitalama_audio_player__name_shm_hitalama_map_widget_float_file_17 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_file['name'] >
		,
		ReturnType< $shm_hitalama_audio_player['name'] >
	>
	type $mol_button_download__title_shm_hitalama_map_widget_float_file_18 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_download['title'] >
	>
	type $mol_button_download__click_shm_hitalama_map_widget_float_file_19 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_file['download'] >
		,
		ReturnType< $mol_button_download['click'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_float_file_20 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_file_21 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_file['unpacking_embed'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_float_file_22 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_file_23 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_file['unpacking'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_float_file_24 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_file_25 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_file['unpacking'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	export class $shm_hitalama_map_widget_float_file extends $shm_hitalama_map_widget_float {
		title_dom_name( ): string
		name( ): string
		Title( ): $mol_paragraph
		file_size( ): string
		Size_badge( ): $mol_view
		baza_download_progress_width( ): string
		Baza_download_progress_bar( ): $mol_view
		baza_download_progress_status( ): string
		baza_download_progress_color( ): string
		Baza_download_progress_status( ): $mol_text
		Baza_download_progress( ): $mol_view
		baza_download_progress_visible( ): readonly(any)[]
		baza_upload_progress_width( ): string
		Baza_upload_progress_bar( ): $mol_view
		baza_upload_progress_status( ): string
		baza_upload_progress_color( ): string
		Baza_upload_progress_status( ): $mol_text
		Baza_upload_progress( ): $mol_view
		baza_upload_progress_visible( ): readonly(any)[]
		tg_send_status( ): string
		tg_send_status_color( ): string
		Tg_send_status( ): $mol_text
		tg_send_status_visible( ): readonly(any)[]
		tg_send_upload( ): any
		Tg_send_upload( ): $mol_button_minor
		tg_send_upload_visible( ): readonly(any)[]
		audio_uri( ): string
		Player( ): $shm_hitalama_audio_player
		contextmenu_unpack( ): readonly(any)[]
		download( ): any
		Download( ): $mol_button_download
		unpacking_embed( next?: any ): any
		Unpacking_embed( ): $mol_button_minor
		unpacking( next?: any ): any
		Unpacking( ): $mol_button_minor
		Unpacking_parquet( ): $mol_button_minor
		controls( ): readonly(any)[]
		sub_scrollable( ): readonly(any)[]
		controls_common( ): readonly(any)[]
		controls_tg( ): readonly(any)[]
		controls_audio( ): readonly(any)[]
		contextmenu_body( ): readonly(any)[]
		contextmenu_for( ): Record<string, any>
	}
	
}

//# sourceMappingURL=file.view.tree.d.ts.map